<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <v-card>
      <v-card-title>
        <span class="headline">Destinatários</span>
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item v-for="(item, idx) in Items" :key="idx" :color="$primary">
            <v-list-item>
              <v-icon class="mr-3" color="grey lighten-2" large>mdi-account-circle</v-icon>
              <v-list-item-content>
                <v-list-item-title>{{getUtilizador(item.id_utilizador)}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="$primary" text @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    getSession() {
      return this.$store.getters["session/getState"]
    }
  },
  data: () => ({
    dialog: false,
    Items: []
  }),
  watch: {},
  mounted() {},
  created() {
    this.$eventBus.$on("DestinatariosDialog", (state, data) => {
      this.Items = [].concat(state)
      this.dialog = state
    })
  },
  methods: {
    getUtilizador(id) {
      return this.$store.getters["utilizador/getById"](id)
    },
    close() {
      this.dialog = false

      setTimeout(() => {
        this.Items = []
      }, 110)
    }
  }
}
</script>
<style scoped>
.v-list-item {
  padding: 0 !important;
}
</style>
